import { isArray } from 'util';
import { parseNumber } from '../../utils/number.utils';
import { UserActivityType } from '../user-activity-type';

export class UserActivityTypeBuilder {
  static fromJson(json) {
    return (json)
      ? new UserActivityType(
        parseNumber(json.code),
        json.name
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(UserActivityTypeBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/user-activity-type.builder.ts